import LimitedInventoryVehicleModalContent from './LimitedInventoryVehicleModalContent';

export default LimitedInventoryVehicleModalContent;
